import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import React from 'react';
import PropTypes from 'prop-types';
import {findAllMilestones} from 'Projects/service/ProjectService';

export default function SelectMilestone(props) {
  const {value, onChange, label, ...restProps} = props;
  const findImportedProjects = async () => await findAllMilestones();

  return (
    <SelectEntity
      minCharacters={2}
      getEntities={findImportedProjects}
      getOptionLabel={(milestone) => milestone.name}
      value={value}
      onChange={onChange}
      label={label}
      {...restProps}
    />
  );
}

SelectMilestone.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SelectMilestone.defaultProps = {
  value: null,
  label: 'Milestone',
};
